import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook, Search } from 'lucide-react';
const TikTokIcon = ({
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-404">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-405" />
  </svg>;
const GoogleShoppingIcon = ({
  size = 24
}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-406">
    <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" data-id="element-407" />
    <path d="M3 6h18" data-id="element-408" />
    <path d="M16 10a4 4 0 0 1-8 0" data-id="element-409" />
  </svg>;
export function SocialShopping() {
  const platforms = [{
    name: 'TikTok',
    icon: <TikTokIcon data-id="element-410" />,
    color: 'bg-black text-white hover:bg-zinc-800'
  }, {
    name: 'Instagram',
    icon: <Instagram data-id="element-411" />,
    color: 'bg-[#E4405F] text-white hover:bg-[#d62976]'
  }, {
    name: 'Facebook',
    icon: <Facebook data-id="element-412" />,
    color: 'bg-[#1877F2] text-white hover:bg-[#166fe5]'
  }, {
    name: 'Google Shopping',
    icon: <GoogleShoppingIcon data-id="element-413" />,
    color: 'bg-white text-black border border-gray-200 hover:bg-gray-50'
  }];
  return <section className="py-24 bg-gray-50 border-t border-gray-100" data-id="element-414">
      <div className="container mx-auto px-4" data-id="element-415">
        <div className="text-center mb-16" data-id="element-416">
          <span className="text-gold uppercase tracking-[0.4em] text-[10px] font-bold block mb-4" data-id="element-417">
            Omnichannel
          </span>
          <h2 className="text-3xl md:text-4xl font-serif mb-6 text-black" data-id="element-418">
            Shop TriLyn Wherever You Discover Us
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto" data-id="element-419"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-420">
          {platforms.map((platform, index) => <motion.button key={platform.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className={`flex items-center justify-center gap-4 p-8 rounded-xl transition-all duration-300 shadow-sm hover:shadow-xl group ${platform.color}`} data-id="element-421">
              <div className="p-3 bg-white/10 rounded-full group-hover:scale-110 transition-transform" data-id="element-422">
                {platform.icon}
              </div>
              <span className="font-bold uppercase tracking-widest text-sm" data-id="element-423">
                Shop on {platform.name}
              </span>
            </motion.button>)}
        </div>
      </div>
    </section>;
}